import React, { useEffect, useState } from 'react';
import { AppBar } from '../../pulsechain_components/AppBar';
import { TestnetNotification } from '../../pulsechain_components/TestnetNotification';
import { NetworkStatus } from './NetworkStatus';
import { queryBeaconchain } from '../../utils/queryBeaconchain';
import { Introduction } from './Introduction';
import { SignupSteps } from './SignupSteps';
import { IS_MAINNET } from '../../utils/envVars';

export const LandingPage = (): JSX.Element => {
  const [state, setState] = useState({
    amountEth: 0,
    totalValidators: 0,
    status: 0,
  });

  useEffect(() => {
    (async () => {
      const response = await queryBeaconchain();
      setState({
        amountEth: response.body.amountEth,
        totalValidators: response.body.totalValidators,
        status: response.statusCode,
      });
    })();
  }, []);

  return (
    <>
      <AppBar />
      {!IS_MAINNET && <TestnetNotification />}
      <NetworkStatus {...{ state }} />
      <Introduction />
      <SignupSteps />
    </>
  );
};
